import { Theme } from "../../../components/constants";

export default {
    stepImageDiv:{
        textAlign: "center"
    },
    stepTitleContainer:{
        textAlign: "center",
        marginTop: "10px",
    },
    stepTitleDesc: {
        fontSize: "16px",
        lineHeight: "25px",
        color: Theme.DISABLED_TEXT
    },
    companyDetailsFormContainer:{
        marginTop: "60px",
        display: "flex",
        flexDirection: "column",
        alignSelf: "flex-start",
        width: "100%",
    },
    fieldDiv: {
        display: "flex",
        flexDirection: "column"
    },
    fieldLabel: {
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
    },
    phoneFieldDiv: {
        marginTop: "60px",
    },
    phoneNumberRow: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    phoneDivWError: {
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
    },
    phoneNumberErrorDiv:{
        height: "23px",
    },
    errorMessage: {
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.ERROR_TEXT,
    },
}